module.exports = __webpack_public_path__ + "img/living-curved-sofa.ef9ff159.webp";